import type { Routes } from '@angular/router';

import { EMAIL_UNSUBSCRIBE_PAGE_PATH } from '@malou-io/package-utils';

import { AUTH_ROUTES } from '#core/components/auth/auth.routing';
import { loadCoreTranslations, loadFeatureTranslations } from '#core/i18n/i18n-feature.loader';
import { campaignsMatcher } from '#modules/campaigns/routes/logged-out-campaigns.routing';
import { scanMatcher } from '#modules/scan/routes/scan.routing';
import { wheelOfFortuneMatcher } from '#modules/wheels-of-fortune/routes/logged-out-wheels-of-fortune.routing';

export const LOGGED_OUT_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#shell/layouts/logged-out-layout/logged-out-layout.component').then((m) => m.LoggedOutLayoutComponent),
        children: [
            {
                path: 'auth',
                loadChildren: () => AUTH_ROUTES,
                resolve: {
                    i18n: loadCoreTranslations('auth'),
                },
            },
            {
                matcher: wheelOfFortuneMatcher,
                loadChildren: () =>
                    import('#modules/wheels-of-fortune/routes/logged-out-wheels-of-fortune.routing').then(
                        (m) => m.LOGGED_OUT_WHEELS_OF_FORTUNE_ROUTES
                    ),
                resolve: {
                    i18n: loadFeatureTranslations('wheels-of-fortune', { scope: 'logged-out' }),
                },
            },
            {
                path: 'unsubscribe_report_v2',
                redirectTo: 'unsubscribe_report',
            },
            {
                path: 'unsubscribe_report',
                loadChildren: () => import('#modules/reports/routes/reports.routes').then((m) => m.REPORTS_ROUTES),
                resolve: {
                    i18n: loadFeatureTranslations('reports', { scope: 'logged-out' }),
                },
            },
            {
                path: 'maintenance',
                loadComponent: () => import('#core/maintenance/maintenance.component').then((m) => m.MaintenanceComponent),
            },
            {
                matcher: campaignsMatcher,
                loadChildren: () =>
                    import('#modules/campaigns/routes/logged-out-campaigns.routing').then((m) => m.LOGGED_OUT_CAMPAIGNS_ROUTES),
                resolve: {
                    i18n: loadFeatureTranslations('campaigns', { scope: 'logged-out' }),
                },
            },
            {
                path: 'nps',
                loadChildren: () =>
                    import('#modules/feedback-forms/routes/public-feedback-forms.routes').then((m) => m.PUBLIC_FEEDBACK_FORMS_ROUTES),
                resolve: {
                    i18n: loadFeatureTranslations('feedback-forms', { scope: 'logged-out' }),
                },
            },
            {
                path: 'reviews-copy-clipboard',
                loadComponent: () =>
                    import('#modules/reviews/views/reviews-copy-clipboard/reviews-copy-clipboard.component').then(
                        (m) => m.ReviewsCopyClipboardComponent
                    ),
                resolve: {
                    i18n: loadFeatureTranslations('reviews', { scope: 'logged-out' }),
                },
            },
            {
                // The API builds the footer link of every email from the same constant.
                // `index.html` skips Google Tag Manager, Heap and Google Analytics on this path, which would send its URL and the token in it.
                path: `${EMAIL_UNSUBSCRIBE_PAGE_PATH.slice(1)}/:token`,
                loadComponent: () =>
                    import('#modules/email-unsubscriptions/views/email-unsubscribe/email-unsubscribe.component').then(
                        (m) => m.EmailUnsubscribeComponent
                    ),
                resolve: {
                    i18n: loadFeatureTranslations('email-unsubscriptions', { scope: 'logged-out' }),
                },
            },
            {
                path: '404',
                loadComponent: () =>
                    import('#core/components/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
                resolve: {
                    i18n: loadCoreTranslations('page-not-found'),
                },
            },
            {
                matcher: scanMatcher,
                loadChildren: () => import('#modules/scan/routes/scan.routing').then((m) => m.SCAN_ROUTES),
                resolve: {
                    i18n: loadFeatureTranslations('scan', { scope: 'logged-out' }),
                },
            },
            { path: '**', redirectTo: '404' }, // So the 404 route will be considered as a public route
        ],
    },
];
